import React from 'react';

import AdminDashBoard from '@features/dashboard/components/admin-dashboard/AdminDashBoard';
// import CommercialDashboard from '@features/dashboard/components/commercial-dashboard/CommercialDashboard';

import { checkUserType } from '@utils/Util';

const Dashboard = () => {
	const renderDashboard = () => {
		if (checkUserType('COMMERCIAL')) {
			return <AdminDashBoard />;
		} else {
			return <AdminDashBoard />;
		}
	};

	return <div>{renderDashboard()}</div>;
};

export default Dashboard;
